<template>
  <div v-if="campaign">
    <share-referral-link
      :campaign_id="campaign.id"
      :is-active.sync="isSharingLink"
      @shared="linkShared"
    />
    <v-card>
      <slot name="title">
        <v-toolbar color="grey lighten-4" light tile flat>
          <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
          <div class="flex-grow-1"></div>

          <v-spacer></v-spacer>
          <v-btn
            v-if="campaign.target_users === 'admin'"
            color="primary mr-3"
            @click="isSharingLink = true"
          >
            <v-icon color="light-blue lighten-4">
              mdi-share-outline
            </v-icon>
            Share Referral Link
          </v-btn>

          <campaign-menu
            :campaign.sync="campaign"
            :defaultCampaign.sync="defaultCampaign"
            @update:campaign="$emit('update:dataCampaign', $event)"
            v-if="!hideActions"
          />
        </v-toolbar>
      </slot>

      <v-card-text>
        <v-row>
          <v-col cols="4">
            <key-value title="Id">
              <span class="small" v-text="campaign.id"></span>
            </key-value>
            <key-value title="Campaign Name" :value="campaign.name" />
            <key-value title="Compensation Type" :value="campaign.compensation_type" />
          </v-col>
          <v-col cols="4">
            <key-value
              title="Target Users"
              class="text-capitalize"
              :value="campaign.target_users"
              type="date"
            />
            <key-value
              v-if="campaign.compensation_type === 'euros'"
              title="Min Referral Transfers"
              :value="campaign.min_referral_transfers"
            />
            <key-value
              v-if="campaign.compensation_type === 'euros'"
              title="Min Referral Transfer Amount"
              :value="campaign.min_referral_transfer_amount"
            />
          </v-col>
          <v-col cols="4">
            <key-value title="Start Date" :value="campaign.start_date" type="date" />
            <key-value title="End Date" :value="campaign.end_date" type="date" />
            <key-value title="Activity status">
              <v-icon color="success" size="35" v-if="campaign.is_active"
                >mdi-progress-check</v-icon
              >

              <v-icon color="warning" size="35" v-else>mdi-progress-alert</v-icon>
            </key-value>
            <key-value title="Is Default">
              <p>{{ campaign.is_the_default ? "Yes" : "No" }}</p>
            </key-value>
          </v-col>
        </v-row>
        <v-row v-if="campaign.compensation_type === 'euros'">
          <v-col>
            <key-value title="Referrer Compensation Value">
              <span class="small" v-text="campaign.referrer_compensation_value"></span>
            </key-value>
          </v-col>
          <v-col>
            <key-value title="Referrer Offer">
              <span class="small" v-text="campaign.referrer_offer_label"></span>
            </key-value>
          </v-col>
          <v-col>
            <key-value title="Referred Compensation Value">
              <span class="small" v-text="campaign.referred_compensation_value"></span>
            </key-value>
          </v-col>
          <v-col>
            <key-value title="Referred Offer">
              <span class="small" v-text="campaign.referred_offer_label"></span>
            </key-value>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CampaignMenu from "./campaignMenu";
import ShareReferralLink from "./shareReferralLink";

export default {
  components: { CampaignMenu, ShareReferralLink },
  props: {
    dataCampaign: Object,
    dataDefaultCampaign: Object,
    title: { default: "Campaign details" },
    hideActions: { type: Boolean, default: false },
  },

  data() {
    return {
      campaign: this.dataCampaign,
      defaultCampaign: this.dataDefaultCampaign,
      isSharingLink: false,
    };
  },
  methods: {
    linkShared({ message }) {
      this.isSharingLink = false;
      Notify.success(message);
    },
  },
};
</script>
